import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </span>
              <span className="font-heading font-bold text-xl text-foreground-900">
                韩漫网站
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专注聚合好看的韩国漫画，<br />
              提供在线免费阅读和下拉式浏览体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
              <Link to="/category/lianai" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">恋爱韩漫</Link>
              <Link to="/category/qihuan" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">奇幻韩漫</Link>
              <Link to="/category/dongzuo" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">动作韩漫</Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/xuanyi" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">悬疑韩漫</Link>
              <Link to="/category/gaoxiao" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">搞笑韩漫</Link>
              <Link to="/category/juqing" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">剧情韩漫</Link>
              <Link to="/category/gufeng" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">古风韩漫</Link>
              <Link to="/category/xiaoyuan" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">校园韩漫</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4">联系我们</h4>
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-sm"></i>
                </div>
                <span>contact@example.com</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-global-line text-sm"></i>
                </div>
                <span>www.example.com</span>
              </div>
              <div className="flex gap-3 mt-2">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-primary-600 hover:bg-primary-100 transition-colors cursor-pointer">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-primary-600 hover:bg-primary-100 transition-colors cursor-pointer">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-primary-600 hover:bg-primary-100 transition-colors cursor-pointer">
                  <i className="ri-bilibili-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 韩漫网站 - 好看的韩国漫画在线免费阅读平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}